/**
 * BrandCard Component
 * Displays brand logo (or fallback icon) and links to ProductListingPage
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2 } from 'lucide-react';

const BrandCard = ({ brand, taxonomy = 'equipment-buy' }) => {
  const navigate = useNavigate();

  const handleBrandClick = () => {
    navigate(`/products?taxonomy=${taxonomy}&pa_brand=${brand.slug}`);
  };

  return (
    <div
      onClick={handleBrandClick}
      className="cursor-pointer transition-transform hover:scale-[1.02]"
    >
      {/* Brand Icon / Image Container */}
      <div className="flex justify-center items-center bg-white shadow-soft p-3 rounded-lg home-brands-items">
        <div className="w-[150px] h-[100px] flex items-center justify-center relative ">
          {brand.logo ? (
            <img
              src={brand.logo}
              alt={`${brand.name} logo`}
              className="object-contain w-full h-full rounded-lg"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
          ) : null}

          {/* Fallback Icon */}
          <div
            className={`absolute inset-0 bg-gradient-to-br from-accent-100 to-accent-200 rounded-lg items-center justify-center ${
              brand.logo ? 'hidden' : 'flex'
            }`}
            data-testid="brand-fallback-icon"
          >
            <Building2 className="w-10 h-10 text-yellow-400" />
          </div>
        </div>
      </div>

      {/* Optional Brand Name */}
      {/* 
      <h3 className="text-lg font-display font-semibold text-neutral-800 text-center mt-3">
        {brand.name}
      </h3> 
      */}

      <style jsx>{

          ` 
          .home-brands-items{
            border: 2px solid #eaeaea;
            border-radius:8px;
    }
          .home-brands-items:hover{
          border:2px solid #f90;
          background-color: #fffaeb;
          box-shadow: 0 4px 12px 0 rgb(0 0 0 / 10%);
          }

          .home-brands-items img{
            transition-duration: 300ms;
            transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
          }

          .home-brands-items:hover img{
            transform: scale(1.05);
          }
          
          `
}</style>
    </div>
  );
};

// Loading Skeleton
export const BrandCardSkeleton = () => (
  <div className="bg-white rounded-xl border border-neutral-200 shadow-soft p-6 text-center">
    <div className="flex justify-center mb-4">
      <div className="w-[150px] h-[100px] bg-neutral-200 rounded-lg animate-pulse"></div>
    </div>
    <div className="w-24 h-6 bg-neutral-200 rounded animate-pulse mx-auto"></div>
  </div>
);

export default React.memo(BrandCard);
